export default {
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen,
    isXlsxFormOpen: state => state.xlsxFormIsOpen,
    isWikiOpen: state => state.wikiIsOpen,
    getDataTableOptions: state => state.dataTableOptions,
    getActions: state => state.actions,
    getActionsTemplates: state => state.actionsTemplates,
    getFormActions: state => state.formActions,
    getXlsxFormActions: state => state.xlsxFormActions,
    getRowActions: state => state.rowActions,
    getRowActionsTemplates: state => state.rowActionsTemplates,
    getRowActionsDoctor: state => state.rowActionsDoctor,
    getHeaderFields: state => state.headerFields,
    getHeaderFieldsTemplates: state => state.headerFieldsTemplates,
    getPatientDetailsHeaderFields: state => state.patientDetailsHeaderFields,
    getXlsxFormFields: state => state.xlsxFormFields,
    getRowActionsReadOnly: state => state.rowActionsReadOnly
}
